
import { RevSkeleton } from '@ds/components/Skeleton'

export default {
  components: {
    RevSkeleton,
  },
}
